import React from "react";

// Live Santorini hero background.
// Uses the iconic Santorini photo with a cinematic Ken Burns animation
// (slow zoom + pan) plus a subtle animated overlay to feel alive.
export default function SeaBackground() {
  return (
    <div className="sea-canvas" data-testid="sea-background">
      <div className="santorini-bg" />
      {/* faint moving light to simulate sun shimmer */}
      <div className="shimmer-overlay" />

      {/* Cinematic gradient overlays for premium feel + readable text */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/85" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-transparent to-black/40" />
      <div className="absolute inset-0 pointer-events-none" style={{
        background: "radial-gradient(ellipse at center, transparent 35%, rgba(0,0,0,0.55) 100%)"
      }} />
    </div>
  );
}
